import { z } from 'zod/mini'

export const changePaymentMethodSearchSchema = z.object({
  clientSecret: z.string(),
})
